import { ArchiveCancelIcon } from './ArchiveCancelIcon';

/**
 * author: Colton Wiscombe
 * id 656CE7E5-1C31-4428-A609-703A2AA39DA7
 * name archive-cancel
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-cancel.svg
 * tags
 */
export const BoxCancelIcon = ArchiveCancelIcon;
export default BoxCancelIcon